import fp from 'lodash/fp';
import React from 'react';
import { Col, Grid, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { branch, compose, lifecycle, renderComponent, withProps } from 'recompose';
import { bindActionCreators } from 'redux';
import { routes } from '../../../../constants';
import { isBusinessAdmin, isBusinessUser } from '../../../../services';
import { businessSelector } from '../../../../state/modules/business';
import { cpdPointActions, cpdPointsSelector } from '../../../../state/modules/cpd-points';
import { industryActions } from '../../../../state/modules/industry';
import { industriesSelector } from '../../../../state/modules/industry/selectors';
import { taskActions } from '../../../../state/modules/task';
import { currentUserIndustryId, currentUserSelector, userAfslSelector } from '../../../../state/modules/user';
import { Icon } from '../../../components';
import Loading from '../../loading';
import { AfslSetting, PersonalDetails, PopulatedCompletedTasks, PopulatedCpdActivity } from './partials';
import Qualifications from './qualifications/qualifications';
import TrainingPlanHistory from './training-plan-history';

const ProfessionalProfile = ({
  user,
  userIndustry,
  personalDetailsProps: {
    businesses
  },
  populatedCpdActivityProps: {
    cpdActivity
  },
  populatedCpdActivityDispatch: {
    getCpdPoints
  },
  AfslSettingProps: {
    business,
    afsLicence
  },
  profile
}) => (
    <div className='base-layout'>
      <section id='header--profile' key='profile-header' className='layout--header'>
        <Grid>
          <Row className='button-gutter'>
            <Col xs={12} md={5}>
              <h1><Icon icon='professional-profile-large' /> Professional Profile</h1>
              <hr />
            </Col>
          </Row>
        </Grid>
      </section>
      <div id='section--professional-profile' key='profile-section' className='layout--section'>
        <Grid>
          <PersonalDetails
            enableUpdate={true}
            businesses={businesses}
            user={user}
            isFullWidth={userIndustry && userIndustry.name !== 'Financial Advice'} />
          {
            userIndustry && userIndustry.name === 'Financial Advice' ?
              <AfslSetting
                afsLicence={afsLicence}
                user={user} /> :
              null
          }
          <Qualifications />
          <PopulatedCpdActivity
            detailPageRoute={routes.app.professionalProfile.cpdActivity}
            cpdActivity={cpdActivity}
            getCpdPoints={getCpdPoints}
            unclickable={true}
            user={user} />
          {
            isBusinessAdmin(user) || isBusinessUser(user) ?
              <PopulatedCompletedTasks /> : null
          }
          <TrainingPlanHistory profile={profile} />
        </Grid>
      </div>
    </div>
  );

const mapStateToProps = (state) => ({
  user: currentUserSelector(state),
  userIndustryId: currentUserIndustryId(state),
  industries: industriesSelector(state),
  isFetchingIndustries: state.industry.isFetching,
  personalDetailsProps: {
    businesses: fp.map(({ business }) => business.name)(state.business.businesses)
  },
  AfslSettingProps: {
    business: businessSelector(state),
    afsLicence: userAfslSelector(state)
  },
  populatedCpdActivityProps: {
    cpdActivity: cpdPointsSelector(state),
  },
  profile: state.user.profile
})

const mapDispatchToProps = (dispatch) => ({
  populatedCpdActivityDispatch: {
    getCpdPoints: bindActionCreators(cpdPointActions.cpdPoints.get, dispatch)
  },
  getIndustries: bindActionCreators(industryActions.industries.get, dispatch),
  getTaskCount: bindActionCreators(taskActions.task.getCount, dispatch)
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      const { getIndustries, getTaskCount } = this.props;

      getTaskCount();
      getIndustries();
    }
  }),
  branch(
    ({ isFetchingIndustries }) => isFetchingIndustries,
    renderComponent(Loading)
  ),
  withProps(
    ({ industries, userIndustryId }) => ({
      userIndustry: fp.find(industry => industry.id === userIndustryId)(industries)
    })
  )
)(ProfessionalProfile);



// WEBPACK FOOTER //
// ./src/containers/pages/app/professional-profile/professional-profile.js